import { Icon } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import { UserRedirectsEnum } from '@services/UserService';

import { MovementServiceTypeEnum } from '../enums';
import type { MovementMenuService } from '../types';

export const FIXED_SERVICES: MovementMenuService[] = [
  {
    type: MovementServiceTypeEnum.FIXED,
    primary: true,
    title: 'Acompanhar status das movimentações',
    description: 'Acompanhe as movimentações já realizadas.',
    icon: (
      <Icon
        color={NEW_COLORS.PRIMARY[500]}
        name="actions-b2b-open-in-new"
        size={32}
      />
    ),
    redirects: [
      {
        id: UserRedirectsEnum.MOVEMENT_STATUS,
        title: '',
        description: '',
      },
    ],
  },
  {
    type: MovementServiceTypeEnum.FIXED,
    primary: true,
    title: 'Acompanhar críticas das movimentações',
    description: 'Visualize críticas e pendências das movimentações',
    icon: (
      <Icon
        color={NEW_COLORS.PRIMARY[500]}
        name="actions-b2b-open-in-new"
        size={32}
      />
    ),
    redirects: [
      {
        id: UserRedirectsEnum.REVIEWS_SCREEN_MOVEMENT,
        title: '',
        description: '',
      },
    ],
  },
];
